<!--
 * @Author: zhangyu
 * @Date: 2021-12-23 09:30:02
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-08-19 18:48:45
 * @Description:新增备件领用
-->
<template>
  <div class="home_page">
    <div class="spare_add_page">
      <!-- 面包屑组件 -->
      <Breadcrumb :pageTitle="pageTitle" />
      <div class="page_detail">
        <h2>{{ $t('route.addRequisitionOrder') }}</h2>
        <!-- 步骤条 -->
        <ProgressBar
          style="width: 100%"
          :progressList="steps"
          barTitle=""
          themeColor="blue"
        />
        <el-form
          :model="detailInfo"
          ref="detailInfoform"
          :rules="detailInfoRule"
          label-width="130px"
          label-position="right"
        >
          <div class="base_info box_distance">
            <h2>{{ $t('account.basicInfo') }}</h2>
            <el-row>
              <el-col>
                <el-form-item :label="`${$t('header.companyName')}：`">
                  {{ $store.state.user.company.companyName }}
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('stockNeed.requestTime2')}：`">
                  <label>
                    <el-date-picker
                      v-model="currentDate"
                      type="date"
                      :disabled="true"
                      :placeholder="$t('message.select')"
                    >
                    </el-date-picker>
                  </label>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('stockNeed.requestDelieveryTime')}：`"
                  prop="expectDeliveryDate"
                >
                  <el-date-picker
                    v-model="detailInfo.expectDeliveryDate"
                    type="date"
                    :placeholder="$t('message.select')"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('stockNeed.comment')}：`"
                  prop="orderRemarks"
                >
                  <el-input
                    type="textarea"
                    maxlength="200"
                    v-model="detailInfo.orderRemarks"
                    :placeholder="$t('stockNeed.limitTwoHundred2')"
                    style="width: 600px !important"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('orderlist.customerNo')}：`"
                  prop="custOrderNo"
                >
                  <el-input
                    maxlength="200"
                    v-model="detailInfo.custOrderNo"
                    :placeholder="$t('message.enter')"
                    style="width: 600px !important"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="$t('orderlist.attachment') + '：'"
                  prop="attachmentList"
                >
                  <Upload
                    :buttonText="$t('stockNeed.uploadFile')"
                    :tip="$t('stockNeed.uploadFileNote20')"
                    :limit="20"
                    :action="action"
                    @onSuccess="getFileList"
                  ></Upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="address_info box_distance">
            <h2>
              {{ $t('order.address') }}
              <div class="addBtn-box" @click="addAddress">
                <img src="@/assets/img/order/addBtn.png" />{{
                  $t('order.newAddress')
                }}
              </div>
            </h2>
            <el-form-item label-width="0" prop="addressId">
              <AddressBox
                :addressList="addressList"
                :showAddressVisible="showAddressVisible"
                :checkedAddressId="detailInfo.addressId"
                @addressChangeHandle="addressChangeHandle"
                @addressEditHandle="addressEditHandle"
                @addressDeleteHandle="addressDeleteHandle"
                @toggleAddress="toggleAddress"
              />
            </el-form-item>
          </div>
          <div class="invoice_info box_distance">
            <h2>
              发票信息
              <div class="addBtn-box" @click="invoiceAddHandle">
                <img src="@/assets/img/order/addBtn.png" />新增发票
              </div>
            </h2>
            <el-form-item label-width="0" prop="orderInvoiceId">
              <BillTabs
                :payInvoiceInfoList="payInvoiceInfoList"
                :moreInvoiceVisible="moreInvoiceVisible"
                :checkedInvoiceId="detailInfo.orderInvoiceId"
                @billChangeHandle="billChangeHandle"
                @invoiceEditHandle="invoiceEditHandle"
                @invoiceDeleteHandle="invoiceDeleteHandle"
                @toggleInvoice="toggleInvoice"
              />
            </el-form-item>
          </div>
          <div class="produce_info box_distance">
            <h2>{{ $t('stockNeed.items') }}</h2>
            <div>
              <el-button
                type="primary"
                style="background: #3d88d4; color: #fff; border-color: #3d88d4"
                @click="openDialogHandle"
              >
                新增
              </el-button>
              <el-button
                type="primary"
                style="background: #3d88d4; color: #fff; border-color: #3d88d4"
                @click="importInfo()"
              >
                {{ $t('stockNeed.stockUpload') }}
              </el-button>
              <el-upload
                v-show="false"
                ref="fielUplod"
                :on-success="fileSuccess"
                :on-error="fileError"
                accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :headers="headerMsg"
                :action="upLoadUrl"
              >
                <el-button type="primary">{{ $t('oss.upload') }}</el-button>
              </el-upload>
              <el-button
                style="margin-left: 10px"
                type="text"
                @click="downloadTemplate('17')"
              >
                {{ $t('stockNeed.downloadTemp2') }}
              </el-button>
              <el-button
                style="margin-left: 10px"
                type="text"
                @click="downloadTemplate('23')"
              >
                {{ $t('stockNeed.downloadTemp3') }}
              </el-button>
            </div>
            <el-form-item label-width="0" prop="receiveDetailList">
              <div
                style="
                  border: 1px solid #ddd;
                  border-bottom: none;
                  margin-top: 10px;
                "
              >
                <el-table
                  ref="goodsTable"
                  size="small"
                  :data="detailInfo.receiveDetailList"
                  :header-cell-style="{ background: '#f9f9f9' }"
                  style="width: 100%"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    :label="$t('product.id')"
                  ></el-table-column>
                  <el-table-column
                    prop="oldGoodsCode"
                    header-align="center"
                    align="center"
                    :label="$t('product.codes')"
                    width="150"
                    class="goodsCode"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="
                          'receiveDetailList.' + scope.$index + '.oldGoodsCode'
                        "
                        :rules="detailInfoRule['oldGoodsCode']"
                      >
                        <el-autocomplete
                          :minlength="2"
                          v-model.trim="scope.row.oldGoodsCode"
                          :fetch-suggestions="querySearchAsync"
                          :placeholder="$t('evaluate.placeholder')"
                          @input="(e) => handleChange(e, scope, scope.$index)"
                          @select="handleSelect($event, scope.$index)"
                          style="width: 105px !important"
                          popper-class="my-kqoption-spareGetAdd"
                          :maxlength="20"
                        ></el-autocomplete>
                      </el-form-item>

                      <!-- <i
                        style="position: absolute; right: 10px; top: 20px"
                        v-if="!scope.row.custspId && !scope.row.oldGoodsCode"
                        class="el-icon-search"
                        @click="openDialogHandle(scope.row, scope.$index)"
                      ></i> -->
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="oldGoodsName"
                    header-align="center"
                    align="center"
                    :label="$t('ordervote.productName')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="oldSpecification"
                    header-align="center"
                    align="center"
                    :label="$t('common.specification')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="oldModel"
                    header-align="center"
                    align="center"
                    :label="$t('common.model')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="brand"
                    header-align="center"
                    align="center"
                    :label="$t('common.brand')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="sellingUnit"
                    header-align="center"
                    width="100px"
                    align="center"
                    :label="`${$t('cart.column3')}/${$t('cart.column4')}`"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row.goodsPrice | formatePrice4 }}/{{
                        scope.row.sellingUnit || '-'
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="oldRemark"
                    header-align="center"
                    align="center"
                    :label="$t('dict.remark')"
                    width="200px"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="textarea"
                        :placeholder="$t('stockNeed.enterRemark')"
                        v-model="scope.row.oldRemark"
                        clearable
                        maxlength="300"
                        :rows="2"
                        resize="none"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="safetyStockQuantity"
                    header-align="center"
                    align="center"
                    label="备件数量"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goodsNum"
                    header-align="center"
                    align="center"
                    :label="$t('stockNeed.getAmount')"
                    width="120px"
                  >
                    <template slot-scope="scope">
                      <el-tooltip
                        v-if="scope.row.oldGoodsCode"
                        placement="top"
                        :content="`起订量${scope.row.moq || 1}, 步长${
                          scope.row.sellingUnitStepSize || 1
                        }`"
                      >
                        <span>
                          <el-input-number
                            style="width: 100px"
                            controls-position="right"
                            v-model="scope.row.goodsNum"
                            :precision="0"
                            :min="1"
                            :max="999999999"
                            :step="scope.row.sellingUnitStepSize || 1"
                            @change="
                              (currentValue, oldValue) =>
                                changeAmount(
                                  currentValue,
                                  oldValue || 0,
                                  scope.row,
                                  scope.$index
                                )
                            "
                          ></el-input-number>
                        </span>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    :label="$t('handle')"
                    width="60px"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteHandle(scope.row, scope.$index)"
                        >{{ $t('delete') }}</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>
          <div v-if="contractList.length">
            <el-checkbox
              v-model="adoptContractAgree"
              true-label="1"
              false-label="0"
              text-color="#333333"
              fill="#1D65A8"
            >
            </el-checkbox>
            相关买卖条款以<a class="pointer" @click="contractVisible = true"
              >框架协议</a
            >内容为准，下单即代表买卖双方均同意此协议
          </div>
          <div class="total_info box_distance">
            <div
              v-if="
                detailInfo.excessMemo !== null && detailInfo.excessMemo !== ''
              "
              style="display: inline-block; margin-top: 15px; margin-left: 15px"
            >
              <el-form
                :model="dataForm"
                :inline="true"
                ref="dataForm"
                label-position="left"
                class="demo-form-inline"
              >
                <el-form-item
                  :label="$t('stockNeed.exceedHolder')"
                  prop="excessMemo"
                >
                  <label>
                    <el-input
                      type="textarea"
                      maxlength="200"
                      :placeholder="$t('stockNeed.exceedReasonHolder')"
                      v-model.trim="detailInfo.excessMemo"
                      style="width: 460px !important"
                      :rows="2"
                    ></el-input>
                  </label>
                </el-form-item>
              </el-form>
            </div>
            <div
              style="display: inline-block; position: absolute; right: 300px"
            >
              <p class="total_produce">
                {{ $t('stockNeed.total1') }}{{ produceTypeNum }}
                {{ $t('stockNeed.total2') }} {{ produceNum }}
                {{ $t('stockNeed.total3') }}
              </p>
              <p class="total_price">
                {{ $t('stockNeed.totalPrice') }}：<span class="price"
                  >{{ $t('common.currency') }}{{ price | formatePrice4 }}</span
                >
              </p>
            </div>
            <div class="submit_btn_group" v-if="!approval">
              <div @click="handleSave(true)" class="submit_btn2">提交审批</div>
              <div @click="handleSave(false)" class="submit_btn">直接领用</div>
            </div>
            <div class="submit_btn_group2" v-else>
              <div @click="handleSave(true)" class="submit_btn3">提交审批</div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 新增/编辑收货地址 弹窗 -->
    <EditAddressDialog
      :editAddressVisible="editAddressVisible"
      :editAddressInfo="editAddressInfo"
      :buttonLoading="buttonLoading"
      @handleClose2="handleClose2"
      @handleAddressSaved="handleAddressSaved"
    />
    <!-- 新增/编辑发票 弹窗 -->
    <EditBillDialog
      :invoiceVisible="invoiceVisible"
      :invoiceForm="invoiceForm"
      :buttonLoading="buttonLoading"
      @closeInviceHandle="closeInviceHandle"
      @invoiceSaveHandle="invoiceSaveHandle"
    />
    <!-- 删除提示 弹窗 -->
    <el-dialog
      title=""
      :visible.sync="addressDeleteVisible"
      width="30%"
      :before-close="
        () => {
          addressDeleteVisible = false
        }
      "
    >
      <span>{{ $t('message.deleteAddress') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addressDeleteVisible = false"
          :loading="buttonLoading"
          >{{ $t('cancel') }}</el-button
        >
        <el-button
          type="primary"
          @click="confirmAddDelete"
          :loading="buttonLoading"
          >{{ $t('confirm') }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 备件选择 -->
    <el-dialog
      :visible.sync="searchVisible"
      :close-on-click-modal="false"
      :before-close="cancelGoods"
      :title="$t('stockNeed.chooseSpare')"
      width="1200px"
      class="produce_dialog"
    >
      <SearchGoods
        v-if="searchVisible"
        :dataList="detailInfo.receiveDetailList"
        @selected="confirmPush"
        @close="searchVisible = false"
        :companyId="companyId"
      />
    </el-dialog>
    <!-- 批量导入失败原由 -->
    <el-dialog
      title="批量导入失败原由"
      :close-on-click-modal="false"
      :visible.sync="importVisible"
      width="530px"
    >
      <div v-html="errorContent"></div>
      <span slot="footer">
        <div class="addFunc">
          <el-button
            style="background-color: #3d88d4; border: 0"
            type="primary"
            @click="handleExportFailed()"
            >查看失败信息</el-button
          >
        </div>
      </span>
    </el-dialog>
    <!-- 失败记录弹窗 -->
    <el-dialog
      :visible.sync="exportVisible"
      :close-on-click-modal="false"
      :before-close="cancelFail"
      title="失败记录"
      width="990px"
    >
      <el-form
        :model="dataForm3"
        :inline="true"
        ref="dataForm2"
        class="demo-form-inline"
        label-width="160px"
      >
        <div class="tip">
          <div>
            导入文件共{{ successCount + failCount }}条，匹配成功{{
              successCount
            }}条,失败<span class="failCount">{{ failCount }}</span
            >条
          </div>
          <el-row>
            <el-button
              style="background-color: #3d88d4; border: 0"
              type="primary"
              @click="handleFailExport()"
              >导出</el-button
            >
          </el-row>
        </div>
        <el-table
          :data="dataFailedList"
          border
          v-loading="dataListLoading"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="oldGoodsCode"
            header-align="center"
            align="left"
            width="150"
            label="物品编码"
          >
          </el-table-column>
          <el-table-column
            prop="oldSpecification"
            header-align="center"
            align="left"
            label="规格"
          >
          </el-table-column>
          <el-table-column
            prop="goodsCode"
            header-align="center"
            align="left"
            label="平台物料编码"
          >
          </el-table-column>
          <el-table-column
            prop="oldModel"
            header-align="center"
            align="left"
            label="型号"
          >
          </el-table-column>
          <el-table-column
            prop="goodsNum"
            header-align="center"
            align="center"
            label="领用数量"
          >
          </el-table-column>
          <el-table-column
            prop="msg"
            header-align="center"
            align="center"
            label="失败原因"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top: 10px; text-align: center"
          layout="prev, pager, next, total, jumper"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          :total="total"
        ></el-pagination>
      </el-form>
      <div class="addFunc">
        <el-button @click="cancelFail">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 领用超量原因 -->
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="cancelAdd"
      :title="$t('stockNeed.exceedTitle')"
      width="800px"
    >
      <el-form
        :model="dataForm"
        :inline="true"
        ref="dataForm"
        label-position="top"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('stockNeed.exceedHolder')"
              prop="excessMemo"
            >
              <label>
                <el-input
                  type="textarea"
                  maxlength="200"
                  :placeholder="$t('stockNeed.exceedReasonHolder')"
                  v-model.trim="detailInfo.excessMemo"
                  style="width: 760px !important"
                  :rows="3"
                ></el-input>
              </label>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="addFunc">
          <el-button
            style="background-color: #3d88d4; border: 0; width: 96px"
            type="primary"
            @click="handleSaveReason()"
            :class="subLoading ? 'but-loading' : ''"
            >{{ $t('confirm') }}</el-button
          >
          <el-button
            style="background-color: #fff; color: #3d88d4; width: 96px"
            type="primary"
            @click="cancelAdd()"
            >{{ $t('cancel') }}</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <ErrorTip ref="errorTip"></ErrorTip>
    <!-- 失败记录弹窗 -->
    <el-dialog
      :visible.sync="contractVisible"
      :close-on-click-modal="false"
      :before-close="() => (contractVisible = false)"
      title="框架协议"
      width="600px"
    >
      <el-table :data="contractList" border style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="fileName"
          align="center"
          show-overflow-tooltip
          label="名称"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          align="center"
          show-overflow-tooltip
          label="公司名称"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          width="160"
          label="上传日期"
        >
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <a
              class="pointer"
              v-if="scope.row.url"
              @click="openUrl(scope.row.url)"
              >下载</a
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="addFunc">
        <el-button size="small" @click="contractVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="800px">
      <div>
        领用单审批为集团客户专享功能，请登录 WEB_SHOP云采平台
        <a href="https://partner.plantmate.com/login" target="_blank"
          >https://partner.plantmate.com/login</a
        >
        <Copyable style="top: 2px;" :text="`https://partner.plantmate.com/login`"></Copyable>
        进行领用。<br />
        审批过程中单据将不会在商城展示，请登录云采平台查看。<br />
        有疑问请联系系统管理员，谢谢！
      </div>
      <div slot="footer" style="text-align: center" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Breadcrumb from '@/components/breadcrumb/index'
import Upload from '@/components/upload/file'
import ProgressBar from '../components/progressBar.vue'
import AddressBox from '../../order/components/addressList.vue'
import EditAddressDialog from '../../order/components/editAddressDialog'
import BillTabs from '../../order/components/billTabs'
import EditBillDialog from '../../order/components/editBillDialog'
import SearchGoods from '../../order/components/searchGoods'
import Copyable from '@/components/copyable.vue'
import debounce from 'lodash/debounce'
import { getAccessToken } from '@/utils/userInfo'
import axios from 'axios'
import ErrorTip from '../components/errorTip.vue'

export default {
  components: {
    Breadcrumb,
    ProgressBar,
    AddressBox,
    EditAddressDialog,
    BillTabs,
    EditBillDialog,
    Upload,
    ErrorTip,
    Copyable,
    SearchGoods
  },
  data () {
    const validateGoodsNum = (rule, value, callback) => {
      const temp = Number(value)
      if (isNaN(temp)) {
        callback(new Error('请输入正确的领用数量'))
      } else if (temp === 0) {
        callback(new Error('领用数量不能为0'))
      } else {
        callback()
      }
    }
    return {
      contractVisible: false,
      contractList: [], // 框架协议列表
      adoptContractAgree: '0',
      approval: false,
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/upload',
      buttonLoading: false, // 加载中
      showAddressVisible: true,
      moreInvoiceVisible: true,
      invoiceVisible: false, // 发票弹窗
      invoiceForm: {}, // 发票信息
      editAddressInfo: {}, // 编辑地址信息
      editAddressVisible: false, // 编辑地址弹窗
      addressDeleteId: null, // 删除地址ID
      addressDeleteVisible: false, // 删除地址确认弹窗
      searchVisible: false, // 物料列表弹窗
      // 面包屑
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareOrder'),
          url: '/spareGetList'
        },
        {
          label: this.$t('route.addRequisitionOrder')
        }
      ],
      steps: [
        { title: this.$t('stockNeed.submit3'), status: 'current' },
        { title: this.$t('applystatus.waiting'), status: 'unfinished' },
        { title: this.$t('stockNeed.tabs5'), status: 'unfinished' },
        { title: this.$t('stockNeed.tabs6'), status: 'unfinished' },
        { title: this.$t('applystatus.beComplete'), status: 'unfinished' }
      ], // 进度条状态数组
      active: 0, // 进度条当前活动情况
      currentDate: Date.now(),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      detailInfo: {
        companyId: '',
        expectDeliveryDate: null, // 要求到货时间
        orderRemarks: null, // 备注
        orderInvoiceId: '', // 发票Id
        addressId: null, // 地址Id
        expedited: '', // 是否加急
        payOrderInvoice: null, // 选中的-发票信息
        payOrderAddress: null, // 选中的-地址信息
        excessMemo: '', // 领用超量原因
        custOrderNo: '', // 客户单号
        receiveDetailList: [], // 备件列表
        attachmentList: [] // 附件列表
      },
      detailInfoRule: {
        expectDeliveryDate: [
          {
            required: true,
            message: this.$t('message.emptyDate'),
            trigger: 'change'
          }
        ],
        addressId: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        receiveDetailList: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        oldGoodsCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        goodsNum: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          },
          { validator: validateGoodsNum, trigger: 'change' }
        ]
      },
      detailListInfoform: {
        oldGoodsCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ]
      },
      addressList: [], // 地址列表
      payInvoiceInfoList: [], // 发票列表
      goodsList: [], // 物料信息列表
      currentIndex: '',
      dataForm2: {
        specification: '',
        edition: '',
        goodsName: '',
        custGoodsCode: '', // 用户物品编码
        goodsCode: '', // 平台物料编码
        model: '' // 型号
      },
      dataListLoading: false,
      headerMsg: { Authorization: 'Bearer ' + getAccessToken() },
      upLoadUrl: '',
      importVisible: false, // 导入弹框
      exportVisible: false,
      errorContent: '',
      currentPage: 1,
      total: 0,
      pageSize: 10,
      dataFailedList: [],
      dataForm3: {
        customerCode: ''
      },
      subLoading: false,
      changeAble: false,
      oweFeeFlag: '',
      visible: false, // 超量原因填写弹窗
      // 超量原因信息
      dataForm: {
        id: '',
        dateValue: '',
        expedited: 1,
        name: '',
        remarks: '',
        expectDeliveryDate: ''
      },
      invoiceActive: 'third',
      successCount: 0,
      failCount: 0,
      dialogVisible: false
    }
  },
  computed: {
    companyId () {
      return this.$store.state.user.defaultCompanyId
    },
    produceTypeNum () {
      if (this.detailInfo.receiveDetailList) {
        return this.detailInfo.receiveDetailList.length
      }
      return 0
    },
    produceNum () {
      let res = 0
      if (this.detailInfo.receiveDetailList) {
        this.detailInfo.receiveDetailList.forEach((item) => {
          if (!isNaN(Number(item.goodsNum))) {
            res += Number(item.goodsNum)
          }
        })
      }
      if (isNaN(res)) {
        return 0
      } else {
        return res
      }
    },
    price () {
      let res = 0
      if (this.detailInfo.receiveDetailList) {
        this.detailInfo.receiveDetailList.forEach((item) => {
          if (item.goodsNum && item.goodsPrice) {
            let tempPrice = Number(item.goodsPrice) * Number(item.goodsNum)
            if (!isNaN(tempPrice)) {
              res += tempPrice
            }
          }
        })
      }
      if (isNaN(res)) {
        return 0
      } else {
        return res
      }
    }
  },
  watch: {
    detailInfo: {
      handler (newQuestion, oldQuestion) {
        let falg = true
        // console.log(newQuestion)
        newQuestion.receiveDetailList.forEach((item, index) => {
          if (
            item.safetyStockQuantity &&
            item.goodsNum > item.safetyStockQuantity
          ) {
            falg = false
          }
        })
        if (falg && this.detailInfo.excessMemo) {
          this.detailInfo.excessMemo = ''
        }
      },
      deep: true
    }
  },
  methods: {
    getMustApproval () {
      this.$http
        .post(
          `/front/webshop/cust-company-process-config/v1/is-must-approval`,
          { procDefKey: 'WEBSHOP_SPARE_PARTS_RECEIPT_AUDIT' }
        )
        .then(({ data: { code, data } }) => {
          console.log(data)
          if (code === 0) {
            this.approval = data
          } else {
            this.approval = false
          }
        })
    },
    getFileList (fileList) {
      this.detailInfo.attachmentList = fileList
    },
    // 修改步长
    changeAmount (currentValue, oldValue, val, index) {
      console.log(currentValue, oldValue, val, index)
      const value = this.detailInfo.receiveDetailList[index]
      // !value.sellingUnitStepSize && (value.sellingUnitStepSize = 8);
      if (
        value.sellingUnitStepSize &&
        currentValue % value.sellingUnitStepSize !== 0
      ) {
        const num =
          currentValue > oldValue
            ? -(currentValue % value.sellingUnitStepSize)
            : value.sellingUnitStepSize -
              (currentValue % value.sellingUnitStepSize)
        if (num !== 0) {
          this.$nextTick(() => {
            this.$set(
              this.detailInfo.receiveDetailList[index],
              'goodsNum',
              currentValue + num
            )
          })
        }
      }
    },
    // 获取地址信息
    getAddressList () {
      let defaultCompanyId =
        localStorage.getItem('defaultCompanyId') !== ''
          ? localStorage.getItem('defaultCompanyId')
          : null
      let url =
        `/front/consumer/user/address/userAddressList?companyId=` +
        defaultCompanyId
      // if (this.isOrder) {
      //   url =
      //     `/front/consumer/order/queryOrderAddressList?orderId=` +
      //     this.$route.query.id
      // }
      let _this = this
      this.$http.get(url).then(({ data: res }) => {
        _this.addressList = res.data
        // console.log(this.addressList)
        _this.setAddress(res.data)
      })
    },
    // 设置收货地址 及默认选中项
    setAddress (res) {
      let _this = this
      _this.addressList = res || []
      if (_this.detailInfo.addressId) {
        let address = _this.addressList.find((item) => {
          return item.userAddressId === _this.detailInfo.addressId
        })
        if (!address) {
          _this.detailInfo.addressId = null
          _this.detailInfo.payOrderAddress = null
        } else {
          _this.detailInfo.payOrderAddress = address
        }
      }
      if (!_this.detailInfo.addressId && _this.addressList.length) {
        let address = _this.addressList.find((item) => {
          return item.defaultAddress === true
        })
        if (address) {
          _this.detailInfo.addressId = address.userAddressId
          _this.detailInfo.payOrderAddress = address
        } else {
          _this.detailInfo.addressId = _this.addressList[0].userAddressId
          _this.detailInfo.payOrderAddress = _this.addressList[0]
          // _this.addressChangeHandle(_this.addressList[0].userAddressId);
        }
      }
    },
    // 更改选中的地址
    addressChangeHandle (item) {
      this.detailInfo.addressId = item.userAddressId
      this.detailInfo.payOrderAddress = item
      if (this.asAddress) {
        this.handleAsAddress()
      }
    },
    // 编辑地址
    addressEditHandle (row) {
      this.editAddressInfo = {
        companyId: row.companyId, // 当前地址对应的公司Id
        userAddressId: row.userAddressId,
        proCityArea: [],
        address: row.address, // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: row.receiveGoodsPerson, // 收货人
        receiveGoodsPhone: row.receiveGoodsPhone, // 收货联系电话
        defaultAddress: row.defaultAddress, // 是否默认地址
        used: row.used // 是否可用
      }
      if (row.province) {
        this.editAddressInfo.proCityArea.push(row.province)
        if (row.city) {
          this.editAddressInfo.proCityArea.push(row.city)
          if (row.area) {
            this.editAddressInfo.proCityArea.push(row.area)
          }
        }
      }
      this.editAddressVisible = true
    },
    // 保存地址-新增/修改
    handleAddressSaved: debounce(
      function () {
        this.editAddressInfo.province = this.editAddressInfo.proCityArea[0]
        this.editAddressInfo.city = this.editAddressInfo.proCityArea[1]
        this.editAddressInfo.area = this.editAddressInfo.proCityArea[2]
        this.editAddressInfo.orderAddress =
          this.editAddressInfo.proCityArea.join('') +
          this.editAddressInfo.address
        var _this = this
        this.$http
          .post(
            `/front/consumer/user/address/${
              _this.editAddressInfo.userAddressId
                ? 'updateUserAddress'
                : 'addUserAddress'
            }`,
            this.editAddressInfo
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            _this.$message.success(this.$t('message.handleSuccess'))
            _this.handleClose2()
            _this.getAddressList()
          })
          .catch(() => {})
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 关闭弹窗  地址
    handleClose2 () {
      this.editAddressVisible = false
      this.editAddressInfo = {
        companyId: '', // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
    },
    // 删除地址
    addressDeleteHandle (row) {
      this.addressDeleteId = row.userAddressId
      this.addressDeleteVisible = true
    },
    toggleAddress (flag) {
      this.showAddressVisible = !flag
    },
    // 添加地址
    addAddress () {
      this.editAddressInfo = {
        // companyId: this.params.companyId, // 当前地址对应的公司Id
        companyId: this.companyId, // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
      this.editAddressVisible = true
    },
    // 确认删除地址
    confirmAddDelete () {
      if (!this.addressDeleteId) {
        this.addressDeleteVisible = false
        return false
      }
      this.$http
        .post(`/front/consumer/user/address/deleteById/${this.addressDeleteId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.addressDeleteVisible = false
          this.getAddressList()
        })
    },
    // 获取发票信息
    getInvoicList () {
      var _this = this
      this.$request
        .get(
          `/front/consumer/order/payinvoice/selectUserAllInvoiceList?companyId=${this.companyId}`
        )
        .then((res) => {
          _this.payInvoiceInfoList = res || []
          if (_this.detailInfo.orderInvoiceId) {
            // 若有选中的项
            let invoiceInfo = _this.payInvoiceInfoList.find((item) => {
              return item.invoiceId === _this.detailInfo.orderInvoiceId
            })
            if (!invoiceInfo) {
              _this.detailInfo.orderInvoiceId = ''
              _this.detailInfo.payOrderInvoice = null
            } else {
              _this.detailInfo.payOrderInvoice = invoiceInfo
            }
          }
          if (
            !_this.detailInfo.orderInvoiceId &&
            _this.payInvoiceInfoList.length
          ) {
            // 若有默认项
            let invoiceInfo = _this.payInvoiceInfoList.find((item) => {
              // return item.defaultFlag === '10'
              return item.defaultFlag === '1'
            })
            if (invoiceInfo) {
              _this.detailInfo.orderInvoiceId = invoiceInfo.invoiceId
              _this.detailInfo.payOrderInvoice = invoiceInfo
            } else {
              _this.detailInfo.orderInvoiceId = ''
              _this.detailInfo.payOrderInvoice = null
            }
          }
        })
        .catch()
    },
    // 新增发票
    invoiceAddHandle () {
      this.invoiceVisible = true
      // if (this.$refs['invoiceForm']) {
      //     this.$refs['invoiceForm'].resetFields()
      // }
      this.invoiceForm = {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '20', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        // defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        defaultFlag: '1', //  默认发票标识 1 默认 0 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      }
    },
    billChangeHandle (item) {
      this.detailInfo.orderInvoiceId = item.invoiceId
      this.detailInfo.payOrderInvoice = item
    },
    // 编辑发票
    invoiceEditHandle (row) {
      this.invoiceVisible = true
      // if (this.$refs['invoiceForm']) {
      //     this.$refs['invoiceForm'].resetFields()
      // }
      this.invoiceForm = {
        // flagAdd: row.defaultFlag === '10',
        flagAdd: row.defaultFlag === '1',
        invoiceId: row.invoiceId,
        invoiceObjType: row.invoiceObjType, // 开票对象类型 10 个人 20 单位
        invoiceObjId: row.invoiceObjId, // 开票对象10 用户id 20 公司id
        invoiceType: row.invoiceType, // 开票类型10 普通发票 20 增值税发票
        companyName: row.companyName, // 开票公司名称(发票抬头)
        taxpayerIdentity: row.taxpayerIdentity, // 纳税人识别号
        companyAddress: row.companyAddress, // 公司地址
        companyPhone: row.companyPhone, // 联系电话
        openingBank: row.openingBank, // 开户行
        bankAccountNo: row.bankAccountNo, // 开户行账号
        defaultFlag: row.defaultFlag, //  默认发票标识
        remarks: row.remarks,
        mailingAddress: row.mailingAddress, // 发票邮寄地址
        consignee: row.consignee, // 收货人
        contactInformation: row.contactInformation // 收货人联系方式
      }
    },
    // 删除发票
    invoiceDeleteHandle (row) {
      this.$confirm('此操作将永久删除该发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$http
            .post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              this.getInvoicList()
            })
        })
        .catch(() => {})
    },
    toggleInvoice (flag) {
      this.invoiceActive = flag
      this.moreInvoiceVisible = !flag
    },
    // 关闭发票
    closeInviceHandle () {
      this.invoiceVisible = false
      // this.$refs['invoiceForm'].resetFields()
    },
    // 保存发票
    invoiceSaveHandle: debounce(
      function () {
        if (this.invoiceForm.invoiceObjType === '10') {
          this.invoiceForm.invoiceObjId = ''
        } else {
          this.invoiceForm.invoiceObjId = this.companyId
        }
        this.invoiceForm.companyId = this.companyId
        this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '1' : '0'
        var _this = this
        // console.log(this.invoiceForm)
        this.$http
          .post(
            `/front/consumer/order/payinvoice/${
              _this.invoiceForm.invoiceId ? 'update' : 'save'
            }`,
            _this.invoiceForm
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            _this.$message.success(this.$t('message.handleSuccess'))
            _this.closeInviceHandle()
            _this.getInvoicList()
          })
          .catch(() => {})
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 模板下载
    downloadTemplate (t) {
      const url = this.$getDictLabel('OMS_EXCELL_IMPORT_TYPE', t)
      console.log(url)
      if (!url || url === t) {
        this.$message.error('模板未配置，请联系管理员')
        return
      }
      window.location.href = url
    },
    // 手工增行
    addNew () {
      // 判断最后一条是否选择过
      if (
        this.detailInfo.receiveDetailList.length > 0 &&
        !this.detailInfo.receiveDetailList[
          this.detailInfo.receiveDetailList.length - 1
        ].oldGoodsCode
      ) {
        return
      }
      this.detailInfo.receiveDetailList.push({
        oldGoodsCode: '',
        oldGoodsName: '',
        oldSpecification: '',
        oldModel: '',
        oldRemark: '',
        goodsNum: '',
        oldEdition: '',
        oldConfiguration: '',
        safetyStockQuantity: '',
        goodsPrice: '',
        brand: '',
        sellingUnit: '',
        physicalUnitAmount: '',
        moq: '',
        sellingUnitStepSize: ''
      })
    },
    // 删行
    deleteHandle (row, index) {
      this.detailInfo.receiveDetailList.splice(index, 1)
      // let flag = false
      // this.detailInfo.receiveDetailList.forEach((item) => {
      //   if (item.goodsNum > item.safetyStockQuantity) {
      //     flag = true
      //   }
      // })
      // if (!flag) {
      //   this.detailInfo.excessMemo = ''
      // }
    },
    // 远程搜索
    querySearchAsync (queryString, cb) {
      var array = []
      if (queryString && queryString.length > 1) {
        let params = {
          likeFlag: '1',
          oldGoodsCode: queryString,
          companyId: this.companyId
        }
        this.$http
          .post(`/front/order/lclb/receive/getGoodsByOrdinary`, params)
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                res.data.forEach((item) => {
                  item.value = item.codeSpeciModel
                })
                cb(res.data)
              } else {
                cb(array)
              }
            } else {
              cb(array)
            }
          })
      } else {
        cb(array)
      }
    },
    handleChange (ind, a, index) {
      // const temp = this.detailInfo.receiveDetailList[index]
      // Object.getOwnPropertyNames(
      //   temp
      // ).forEach(function (key) {
      //   console.log(key, temp[key])
      //   temp[key] = ''
      // })
      // this.detailInfo.receiveDetailList[index] = temp
      this.detailInfo.receiveDetailList[index].oldConfiguration = ''
      this.detailInfo.receiveDetailList[index].oldEdition = ''
      this.detailInfo.receiveDetailList[index].oldGoodsName = ''
      this.detailInfo.receiveDetailList[index].oldModel = ''
      this.detailInfo.receiveDetailList[index].oldRemark = ''
      this.detailInfo.receiveDetailList[index].oldSpecification = ''
      this.detailInfo.receiveDetailList[index].brand = ''
      this.detailInfo.receiveDetailList[index].sellingUnit = ''
      this.detailInfo.receiveDetailList[index].safetyStockQuantity = ''
      this.detailInfo.receiveDetailList[index].goodsPrice = ''
      this.detailInfo.receiveDetailList[index].physicalUnitAmount = ''
      this.detailInfo.receiveDetailList[index].moq = ''
      this.detailInfo.receiveDetailList[index].sellingUnitStepSize = ''
      // console.log(this.detailInfo.receiveDetailList)
    },
    handleSelect (item, index) {
      const res = this.detailInfo.receiveDetailList.some((row, i) => {
        if (row.custspId === item.custspId && index !== i) {
          this.detailInfo.receiveDetailList[index].oldGoodsCode = ''
          this.$message.error(this.$t('message.sameSpare', { line: i + 1 }))
          return true
        }
        return false
      })
      if (res) {
        return
      }
      this.detailInfo.receiveDetailList[index].oldConfiguration =
        item.oldConfiguration
      this.detailInfo.receiveDetailList[index].oldEdition = item.oldEdition
      this.detailInfo.receiveDetailList[index].oldGoodsCode = item.oldGoodsCode
      this.detailInfo.receiveDetailList[index].oldGoodsName = item.oldGoodsName
      this.detailInfo.receiveDetailList[index].oldModel = item.oldModel
      this.detailInfo.receiveDetailList[index].oldRemark = item.oldRemark
      this.detailInfo.receiveDetailList[index].oldSpecification =
        item.oldSpecification
      this.detailInfo.receiveDetailList[index].brand = item.brand
      this.detailInfo.receiveDetailList[index].sellingUnit = item.sellingUnit

      this.detailInfo.receiveDetailList[index].goodsPrice = item.price
      this.detailInfo.receiveDetailList[index].safetyStockQuantity =
        item.safetyStockQuantity
      this.detailInfo.receiveDetailList[index].custspId = item.custspId
      this.detailInfo.receiveDetailList[index].physicalUnitAmount =
        item.physicalUnitAmount
      this.detailInfo.receiveDetailList[index].moq = item.moq
      this.detailInfo.receiveDetailList[index].sellingUnitStepSize =
        item.sellingUnitStepSize
    },
    // 打开物料信息弹窗
    openDialogHandle () {
      this.dataForm2.specification = ''
      this.dataForm2.edition = ''
      this.dataForm2.configuration = []
      this.dataForm2.goodsName = ''
      this.goodsList = []
      // this.currentIndex = index
      this.searchVisible = true
      this.handleCode()
    },
    // 查询物料信息
    handleCode () {
      this.dataListLoading = true
      let params = {
        companyId: this.companyId,
        oldSpecification: this.dataForm2.specification || undefined,
        oldGoodsName: this.dataForm2.goodsName || undefined,
        oldGoodsCode: this.dataForm2.custGoodsCode || undefined,
        goodsCode: this.dataForm2.goodsCode || undefined,
        oldModel: this.dataForm2.model || undefined
      }
      this.$http
        .post(`/front/order/lclb/receive/getSparePartsDetailByOrdinary`, params)
        .then(({ data: res }) => {
          this.goodsList = res.data
          this.dataListLoading = false
          const custspIds = this.detailInfo.receiveDetailList.map(
            (item) => item.custspId
          )
          setTimeout(() => {
            this.goodsList.forEach((item) => {
              if (custspIds.includes(item.custspId)) {
                this.$refs.multipleTable.toggleRowSelection(item, true)
              } else {
                this.$refs.multipleTable.toggleRowSelection(item, false)
              }
            })
          }, 100)
        })
    },
    // 关闭物料信息弹窗
    cancelGoods () {
      this.searchVisible = false
    },
    // 重置物料信息
    handleReset () {
      this.dataForm2 = {
        custGoodsCode: '',
        model: '',
        specification: '',
        goodsName: ''
      }
      this.handleCode()
    },
    // 选中物料
    confirmPush (arr) {
      var newList = []
      // var flag = true
      if (arr) {
        arr.forEach((item) => {
          const {
            oldGoodsCode,
            oldGoodsName,
            oldSpecification,
            oldModel,
            oldRemark,
            safetyStockQuantity,
            custspId,
            oldConfiguration,
            oldEdition,
            brand,
            sellingUnit,
            price,
            physicalUnitAmount,
            moq,
            sellingUnitStepSize,
            skuId
          } = item
          newList.push({
            oldGoodsCode,
            oldGoodsName,
            oldSpecification,
            oldModel,
            oldRemark,
            safetyStockQuantity,
            custspId,
            oldConfiguration,
            oldEdition,
            brand,
            sellingUnit,
            goodsPrice: price,
            physicalUnitAmount,
            moq,
            sellingUnitStepSize,
            skuId
          })
        })
        // 先获取已存在的
        const custspIds = this.detailInfo.receiveDetailList.map(
          (item) => item.custspId
        )
        let dataList = [...this.detailInfo.receiveDetailList]
        dataList = dataList.filter((item) => item.custspId || item.oldGoodsCode)
        newList.forEach((item) => {
          // 不存在的再添加进行
          if (!custspIds.includes(item.custspId)) {
            dataList.push(item)
          }
        })
        this.detailInfo.receiveDetailList = dataList
      }
      this.searchVisible = false
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 双击多选
    handledbClick (row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 选中物料信息
    checkSelectable (row) {
      let res = this.detailInfo.receiveDetailList.some((item) => {
        if (item.custspId === row.custspId) {
          return true
        }
        return false
      })
      return !res
    },
    // 备件选择弹窗关闭
    produceDialogClose () {
      this.$refs.dataForm2.resetFields()
    },
    // 导入成功
    fileSuccess (response, file, fileList) {
      // console.log(response)
      if (response.data && response.code === 0) {
        // this.$message.success(response.message)
        let list = [...response.data]
        list.forEach((item) => {
          item.goodsNum = item.receiveQuantity
          item.sellingUnit = item.physicalUnit
          item.goodsPrice = item.price
        })
        this.detailInfo.receiveDetailList.forEach((item) => {
          for (let i = 0; i < list.length; i++) {
            if (list[i].oldGoodsCode === item.oldGoodsCode) {
              // console.log(list[i].oldGoodsCode)
              // console.log(item.oldGoodsCode)
              item.goodsNum = Number(item.goodsNum) + Number(list[i].goodsNum)
              item.goodsNum += ''
              list.splice(i, 1)
            }
          }
        })
        // console.log(list)
        var totalList = [...this.detailInfo.receiveDetailList, ...list]
        this.detailInfo.receiveDetailList = totalList
        this.handleExportSearch(1, (total) => {
          if (total > 0) {
            this.successCount = response.data.length
            this.failCount = total
            this.exportVisible = true
          } else {
            this.$message.success('导入成功')
          }
        })
      } else {
        this.errorContent = response.message
        this.importVisible = true
      }
    },
    // 导入失败
    fileError (file, fileList) {
      this.$message.error('导入失败，请重新上传')
    },
    setDataList (arr = []) {
      arr.forEach((item) => {
        this.detailInfo.receiveDetailList.push({
          oldGoodsCode: item.oldGoodsCode,
          oldGoodsName: item.oldGoodsName,
          oldSpecification: item.oldSpecification,
          oldModel: item.oldModel,
          oldRemark: item.oldRemark,
          goodsNum: item.goodsNum || item.safetyStockQuantity,
          oldEdition: item.oldEdition,
          oldConfiguration: item.oldConfiguration,
          safetyStockQuantity: item.safetyStockQuantity,
          goodsPrice: item.price,
          brand: item.oldBrand,
          sellingUnit: item.sellingUnit,
          custspId: item.custspId || null,
          physicalUnitAmount: item.physicalUnitAmount || null,
          moq: item.moq || null,
          sellingUnitStepSize: item.sellingUnitStepSize || null,
          skuId: item.skuId || item.goodsSkuId
        })
      })
    },
    getUserInfo () {
      return this.$http
        .get('/front/consumer/usercenter/custUserCenterInfo', {
          params: {
            appCode: 'PLANTMATE_OFFICIAL',
            companyId: this.companyId
          }
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.userInfo = res.data.userInfo
        })
        .catch(() => {})
    },
    // 备件信息上传
    importInfo () {
      // this.$refs.inputer.click()
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导出失败
    handleExportFailed () {
      this.exportVisible = true
      this.importVisible = false
      this.errorContent = ''
      this.handleExportSearch(1, (total) => {
        if (total > 0) {
          this.successCount = 0
          this.failCount = total
          this.exportVisible = true
        }
      })
    },
    handleExportSearch (currentPage = this.currentPage, call) {
      this.currentPage = currentPage
      let params = {
        companyId: this.companyId,
        page: currentPage,
        limit: 10
      }
      this.$http
        .post(`/front/order/lclb/receive/failListByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataFailedList = res.data.data
            this.total = res.data.count
            call && call(this.total)
          } else {
            this.dataFailedList = []
            this.total = 0
          }
        })
    },
    cancelFail () {
      this.exportVisible = false
    },
    // 导出失败记录
    handleFailExport () {
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getAccessToken()
        },
        responseType: 'blob', // 一定要写
        url: `${window.SITE_CONFIG['apiURL']}/front/order/lclb/receive/failExport`,
        data: {
          companyId: this.companyId
        }
      })
        .then((res) => {
          if (res.data.size > 0) {
            const reader = new FileReader()
            reader.onload = (e) => {
              const blob = new Blob([res.data], {
                type: 'application/vnd.ms-excel'
              })
              const date = new Date()
              const month = date.getMonth() + 1
              const day = date.getDate()
              const fileName =
                '失败记录列表' +
                date.getFullYear() +
                (month >= 10 ? month : '0' + month) +
                (day >= 10 ? day : '0' + day) // 下载的文件名
              if ('msSaveOrOpenBlob' in navigator) {
                // 'IE'
                window.navigator.msSaveOrOpenBlob(blob, fileName + '.xls')
              } else {
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = res.headers['content-disposition'] // 下载后文件名
                link.download = fileName
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              }
            }
            reader.readAsText(res.data)
          }
        })
        .catch(() => {})
    },
    // 分页查询导出信息
    handleSizeChange (val) {
      this.handleExportSearch(1)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // console.log(val)
      this.handleExportSearch()
    },
    // 填写领用原因
    handleSaveReason () {
      this.visible = false
    },
    // 关闭领用弹窗
    cancelAdd () {
      this.visible = false
      this.detailInfo.excessMemo = ''
    },
    // 确认
    handleSave (startWorkflow) {
      if (startWorkflow) {
        this.dialogVisible = true
        return
      }
      if (this.subLoading) {
        return false
      }
      if (this.adoptContractAgree !== '1' && this.contractList.length > 0) {
        this.$message.error('请阅读并勾选框架协议！')
        return
      }
      if (this.oweFeeFlag === 1) {
        this.$message.warning(this.$t('message.pleasePay'))
        return
      }
      if (
        this.detailInfo.expectDeliveryDate === '' ||
        this.detailInfo.expectDeliveryDate === null
      ) {
        this.$message.warning(this.$t('message.emptyDate'))
        return
      }
      if (!this.detailInfo.orderInvoiceId && this.invoiceActive !== 'third') {
        this.$message.warning(this.$t('message.emptyInvoice'))
        return
      }
      // 表单校验
      let flagValidate = true
      this.$refs.detailInfoform.validate((valid) => {
        if (!valid) {
          flagValidate = false
        }
      })
      // 领用原因
      let flag = true
      this.detailInfo.receiveDetailList.forEach((item, index) => {
        if (!this.detailInfo.excessMemo) {
          // 超量原因为空
          if (
            item.safetyStockQuantity &&
            item.goodsNum > item.safetyStockQuantity
          ) {
            this.visible = true
            flag = false
          }
        }
      })

      // console.log(flag)
      if (flag && flagValidate) {
        // console.log(this.detailInfo)
        this.subLoading = true
        this.detailInfo.companyId = this.companyId
        // this.invoiceActive
        const obj = {
          ...this.detailInfo,
          startWorkflow,
          platformSource: 2
        }
        if (this.invoiceActive === 'third') {
          delete obj.payOrderInvoice
        }

        const checkObj = {
          companyId: this.companyId,
          orderItemList: this.detailInfo.receiveDetailList.map((i) => {
            return {
              goodsNum: i.goodsNum,
              goodsSkuId: i.skuId || i.goodsSkuId,
              oldGoodsCode: i.oldGoodsCode
            }
          })
        }

        this.$http
          .post(`/front/consumer/order/checkFrontOrderItem`, checkObj)
          .then(({ data: { code, data } }) => {
            if (code === 0) {
              // 校验成功
              if (!(data || []).length) {
                this.submit(obj)
              } else {
                // 校验失败
                this.$refs.errorTip.onShow(
                  data,
                  this.$store.state.user.company.companyName
                )
                this.subLoading = false
              }
            } else {
              this.subLoading = false
            }
          })
      }
    },
    submit (obj) {
      this.$http
        .post(`/front/order/lclb/receive/saveByOrdinary`, obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(this.$t('message.addSuccess'))
            this.subLoading = false
            this.$store.dispatch(
              'setShoppingCartCount',
              this.$store.state.shoppingCartCount + 1
            )
            this.$router.push({ name: 'spareGetList' })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 查询框架协议
    queryFrameAgree () {
      this.$http
        .post('/front/consumer/shopping/order/queryAdoptContractShow', {
          companyId: this.$store.state.user.company.companyId
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$http
              .post(
                '/front/consumer/shopping/order/queryAdoptContractAgreeFileList',
                {
                  contractIdList: res.data
                }
              )
              .then(({ data: res }) => {
                if (res.code === 0) {
                  this.contractList = res.data || []
                }
              })
          }
        })
    },
    openUrl (url) {
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.upLoadUrl =
      window.SITE_CONFIG['apiURL'] +
      `/front/order/lclb/receive/importRByOrdinary?companyId=` +
      this.companyId
    this.getUserInfo()
    if (this.$route.query.getList && this.$route.query.getList === 1) {
      this.setDataList(this.$store.state.lclbDataList)
    }
    this.getAddressList()
    this.getInvoicList()
    this.queryFrameAgree()
    this.getMustApproval()
  }
}
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
<style lang="scss">
.spare_add_page .page_detail {
  background: #fff;
  padding: 30px;
  width: 1190px;
  margin: 0 auto;
  .box_distance {
    margin-top: 20px;
  }
  .el-step__line {
    position: absolute;
    left: 60%;
    width: 80%;
  }
  .addBtn-box {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    color: #3d88d4;
    float: right;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      display: block;
      float: left;
      margin: 2px 6px;
    }
  }
  .goodsCode {
    position: relative;
  }
  .total_info {
    position: relative;
    height: 80px;
    background-color: #eeeeee;
    .total_produce {
      width: 100%;
      height: 20px;
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular;
      white-space: nowrap;
      line-height: 20px;
      text-align: right;
      align-self: flex-end;
    }
    .total_price {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      .price {
        font-size: 16px;
        font-family: PingFangSC-Medium;
        color: rgba(255, 54, 54, 1);
      }
    }
  }
  >>> .bill-box .ad-btnBox {
    width: 170px;
  }
}
.my-kqoption-spareGetAdd {
  width: auto !important;
  max-width: 300px;
}
.addFunc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.produce_dialog {
  .addCancel {
    width: 158px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #3d88d4;
    border: 1px solid #3d88d4;
    margin-right: 10px;
    user-select: none;
    cursor: pointer;
  }
  .addConfirm {
    background-color: #3d88d4;
    color: #fff;
  }
}
.tip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  font-size: 18px;
  color: #1abc9c;
  a {
    margin-left: 12px;
  }
  .failCount {
    color: #d9001b;
  }
}

.submit_btn_group {
  display: inline-block;
  position: absolute;
  right: 10px;
  width: 264px;
  border: 1px solid #ff3636;
  height: 60px;
  border-radius: 10px;
  top: 10px;
}
.submit_btn_group2 {
  display: inline-block;
  position: absolute;
  right: 10px;
  width: 132px;
  height: 60px;
  border-radius: 10px;
  top: 10px;
}
.submit_btn {
  position: absolute;
  display: inline-block;
  right: -1px;
  width: 132px;
  cursor: pointer;
  background-color: #ff3636;
  font-size: 18px;
  line-height: 60px;
  color: #fff;
  text-align: center;
  border-radius: 0 10px 10px 0;
  height: 59px;
}
.submit_btn2 {
  width: 128px;
  cursor: pointer;
  font-size: 18px;
  line-height: 60px;
  text-align: center;
  color: #ff3636;
  display: inline-block;
  position: absolute;
  right: 132px;
  background-color: #ffeded;
  border-radius: 10px 0 0 10px;
  height: 58px;
}
.submit_btn3 {
  width: 128px;
  cursor: pointer;
  font-size: 18px;
  line-height: 60px;
  text-align: center;
  background-color: #ff3636;
  font-size: 18px;
  line-height: 60px;
  color: #fff;
  display: inline-block;
  border-radius: 10px;
  height: 58px;
}
</style>
